import { __decorate } from "tslib";
import { DAY_TYPE_LIST, DAY_TYPE } from "@/common/common-list-enum";
import { Component, Vue } from "vue-property-decorator";
import piHomeCard from "../pi-home-card/pi-home-card.vue";
import { getHomeStatisticsElec, getHomeStatisticsCharge, getHomeStatisticsTrans, getHomeStatisticsUseRate, } from "@/api/api-operation-service";
import { getMerchantStatistics } from "@/api/api-pay-service";
import i18n from "@/config/i18n";
import { piOhGetNumber } from "@/utils/object.helper";
import { piThGetDateStr } from "@/utils/time.helper";
let PiHomeDataStatistics = class PiHomeDataStatistics extends Vue {
    constructor() {
        super(...arguments);
        this.dateType = DAY_TYPE.all;
        this.dateTypeList = DAY_TYPE_LIST;
        this.dataList = [
            {
                name: i18n.t("home.chargeDl"),
                value: 0,
                key: "totalPower",
                icon: require("@/assets/home/data-dl.png"),
                iconBg: require("@/assets/home/data-dl-bg.png"),
                list: [
                    {
                        name: i18n.t("commonTableName.jian"),
                        value: 0,
                        key: "totalSharpPower",
                    },
                    {
                        name: i18n.t("commonTableName.feng"),
                        value: 0,
                        key: "totalPeakPower",
                    },
                    {
                        name: i18n.t("commonTableName.ping"),
                        value: 0,
                        key: "totalFlatPower",
                    },
                    {
                        name: i18n.t("commonTableName.gu"),
                        value: 0,
                        key: "totalValleyPower",
                    },
                ],
            },
            {
                name: i18n.t("home.totalTransAmount"),
                value: 0,
                key: "totalTransAmount",
                icon: require("@/assets/home/data-money.png"),
                iconBg: require("@/assets/home/data-money-bg.png"),
                list: [
                    { name: i18n.t("serverFee"), value: 0, key: "totalTransServiceAmount" },
                    { name: i18n.t("eleFee"), value: 0, key: "totalTransElecAmount" },
                    { name: i18n.t("delayFee"), value: 0, key: "totalTransDelayAmount" },
                ],
            },
            {
                name: i18n.t("home.chargeTimes"),
                value: 0,
                key: "chargeTimes",
                icon: require("@/assets/home/data-charge.png"),
                iconBg: require("@/assets/home/data-charge-bg.png"),
                list: [
                    {
                        name: i18n.t("home.avgChargeTimes"),
                        value: 0,
                        key: "avgChargeTimes",
                    },
                ],
            },
            {
                name: i18n.t("home.useRate"),
                value: "",
                key: "useRate",
                icon: require("@/assets/home/data-use.png"),
                iconBg: require("@/assets/home/data-use-bg.png"),
                unit: "%",
                list: [
                    {
                        name: i18n.t("home.monthAvgUseRate"),
                        value: "",
                        key: "monthAvgUseRate",
                        unit: "%",
                    },
                ],
            },
            {
                name: i18n.t("home.mchIncomeAmount"),
                value: 0,
                key: "mchIncomeAmount",
                icon: require("@/assets/home/data-income.png"),
                iconBg: require("@/assets/home/data-income-bg.png"),
                list: [
                    {
                        name: i18n.t("home.totalIncomeAmount"),
                        value: 0,
                        key: "totalIncomeAmount",
                    },
                    { name: i18n.t("home.mchPayAmount"), value: 0, key: "mchPayAmount" },
                ],
            },
        ];
        this.statisticsData = {};
    }
    /**
     * 请求接口返回数据
     */
    getStatisticsData(getFun) {
        return new Promise((resolve) => {
            getFun({ dateType: this.dateType })
                .then((ret) => {
                if (ret.status === this.$config.apiStatus) {
                    let data = ret.data[0] || {};
                    resolve(data);
                }
                else {
                    resolve({});
                }
            })
                .catch(() => {
                resolve({});
            });
        });
    }
    /**
     * 获取数据
     */
    getMerchantStatistics() {
        return new Promise((resolve) => {
            let beginTime = "";
            let endTime = "";
            if (this.dateType == "1") {
                beginTime = piThGetDateStr(-1) + " 00:00:00";
                endTime = piThGetDateStr(-1) + " 23:59:59";
            }
            else if (this.dateType == "2") {
                beginTime = piThGetDateStr(0) + " 00:00:00";
                endTime = piThGetDateStr(0) + " 23:59:59";
            }
            getMerchantStatistics({
                dateType: this.dateType,
                beginTime: beginTime,
                endTime: endTime,
            })
                .then((ret) => {
                if (ret.status == this["$config"].apiStatus) {
                    let data = ret.data[0] || {};
                    data.totalElectricityCharge = piOhGetNumber(data.totalElectricityCharge || 0);
                    data.totalServiceCharge = piOhGetNumber(data.totalServiceCharge || 0);
                    data.totalStakeCharge = piOhGetNumber(data.totalStakeCharge || 0);
                    data.oprTotal = piOhGetNumber(data.oprTotal || 0);
                    data.serviceCharges = piOhGetNumber(data.serviceCharges || 0);
                    // 实收总金额 = 电费 + 服务费 + 占桩费
                    data.totalIncomeAmount = (data.totalElectricityCharge +
                        data.totalServiceCharge +
                        data.totalStakeCharge).toFixed(2);
                    // 支出总金额 = 运营商分成 + 手续费
                    data.mchPayAmount = (data.oprTotal + data.serviceCharges).toFixed(2);
                    // 收益金额 = 实收总金额 - 支出总金额
                    data.mchIncomeAmount = (data.totalIncomeAmount - data.mchPayAmount).toFixed(2);
                    resolve(data);
                }
                else {
                    resolve({});
                }
            })
                .catch(() => {
                resolve({});
            });
        });
    }
    /**
     * 请求 4个接口，把数据合并在一起
     */
    async getForData() {
        let dlData = await this.getStatisticsData(getHomeStatisticsElec);
        let chargeData = await this.getStatisticsData(getHomeStatisticsCharge);
        let chargeNumberData = await this.getStatisticsData(getHomeStatisticsTrans);
        let useData = await this.getStatisticsData(getHomeStatisticsUseRate);
        let incomeAmountData = await this.getMerchantStatistics();
        this.statisticsData = {
            ...dlData,
            ...chargeData,
            ...chargeNumberData,
            ...useData,
            ...incomeAmountData,
        };
    }
    mounted() {
        this.getForData();
    }
};
PiHomeDataStatistics = __decorate([
    Component({
        components: {
            "pi-home-card": piHomeCard,
        },
    })
], PiHomeDataStatistics);
export default PiHomeDataStatistics;
